var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.72727L6.60155 11.2872C7.00316 11.6784 7.64782 11.663 8.03035 11.2532L12 7",
    stroke: "#FF001A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4L1.87069 13.1422C1.94401 13.9121 2.59059 14.5 3.36393 14.5H13.1361C13.9094 14.5 14.556 13.9121 14.6293 13.1422L15.5 4M1 4H15.5M1 4L1.34383 3.82809C1.75784 3.62108 2.0531 3.23452 2.14388 2.78062L2.25883 2.20583C2.39906 1.50469 3.01468 1 3.72971 1H12.4845C13.0978 1 13.6494 1.37343 13.8772 1.94291L14.2882 2.97049C14.4246 3.31159 14.6815 3.59075 15.0101 3.75505L15.5 4",
    stroke: "#FF001A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArchive);
export default __webpack_public_path__ + "static/media/ic_archive.995e32760e8fe5e9daddf97672631a85.svg";
export { ForwardRef as ReactComponent };